import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { Field } from "formik";
import { withTranslation } from "react-i18next";

class TransactionMonitoringBoxSingle extends Component {

  render() {
    return (
      <Col md={12} >
        <Row>
          <Col md={7} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <p style={{ marginTop: "15px" }}>{" "}{this.props.t(this.props.BoxName)}</p>
          </Col>
          <Col md={5} style={{ display: "flex", marginTop: "8px", flexDirection: "column", justifyContent: "center", alignItems: "left", }}>
            <Row>
              <Col md={12} style={{ display: "inline" }}>
                <div className="form form-check form-switch form-switch-md">
                  <Field
                    style={{ marginRight: "5px" }}
                    className="form-check-input"
                    name={this.props.fieldName}
                    type="checkbox"
                    disabled={this.props.disabled}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  }
}

TransactionMonitoringBoxSingle.propTypes = {
  fieldName: PropTypes.any,
  value: PropTypes.any,
  BoxName: PropTypes.any,
  disabled: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(TransactionMonitoringBoxSingle);